module.exports = __webpack_public_path__ + "img/IMG_6419 1.3c91f2bd.png";